import { createReducer, on } from '@ngrx/store';
import { BudgetControlItemState, initialBudgetControlItemState } from './budget-control-item.state';
import {
  loadBudgetControlItemsByProject,
  loadBudgetControlItemsByProjectSuccess,
  loadBudgetControlItemsByProjectFailure,
} from './budget-control-item.actions';

export const budgetControlItemReducer = createReducer(
  initialBudgetControlItemState,
  on(loadBudgetControlItemsByProject, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadBudgetControlItemsByProjectSuccess, (state, { items, projectId }) => ({
    ...state,
    items,
    loadedProjectId: projectId,
    loading: false,
  })),
  on(loadBudgetControlItemsByProjectFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
